export default {
  path: 'winter-service/v2/irregularities/:id',
  name: 'WinterService2IrregularityDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/IrregularityDetails.vue')
}
